module.exports = __webpack_public_path__ + "img/house-banner.51f0e9ee.jpg";